import script from "./BaseCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCarousel.vue?vue&type=style&index=0&id=33b0f5cb&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b0f5cb"]])

export default __exports__